import { render, staticRenderFns } from "./AssignRole.vue?vue&type=template&id=e9220298"
import script from "./AssignRole.vue?vue&type=script&lang=js"
export * from "./AssignRole.vue?vue&type=script&lang=js"
import style0 from "./AssignRole.vue?vue&type=style&index=0&id=e9220298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports